<template>
  <div class="locale-changer">
    <select v-model="$i18n.locale" class="group flex items-center w-full h-12 rounded-lg bg-white px-3 text-sm text-gray-400 hover:text-gray-900">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang.code">
        {{ lang.text }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "locale-changer",
  data() {
    return {
      langs: [
        { code: "en", text: "English" },
        { code: "nl", text: "Dutch" },
      ],
    };
  },
};
</script>